import ApiService from '../../../../services/apiService';
import { mapState } from 'vuex';
import intersection from 'lodash/intersection';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
export default {
  name: 'CoreDtwinRuleCopy',
  props: {
    tenantId: {
      type: Number,
      required: true
    },
    dtwinId: {
      type: Number,
      required: true
    },
    states: {
      type: Array,
      required: true
    },
    rule: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      formIsValid: false,
      selectedTargetTwins: [],
      requiredRule: [v => !!v || this.$i18n_t('Common.fieldRequired')],
      targetTwinsStateMetrics: {},
      targetTwinsAggregateStates: {}
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    aggregateStatesOfSourceRule() {
      return (get(this.rule, 'properties.triggeredAggregates') || []).map(triggered => {
        return this.states.find(s => s.id === triggered.stateId);
      }).filter(s => s);
    },
    statesUsedBySourceRule() {
      // return only those states that are used by the rule as metrics or referenced as triggered aggregate-state
      return this.states.filter(state => {
        return intersection([state.id], this.rule.stateIds).length > 0 || intersection([state.id], this.aggregateStatesOfSourceRule.map(agg => agg.id)).length > 0;
      });
    }
  },
  methods: {
    verifyTwinCanBeUsedAsCopyTarget(_twin, _parents, statesOfTwinToVerify) {
      if (this.aggregateStatesOfSourceRule.length > 0) {
        const uniqueBindingTypes = uniq(this.aggregateStatesOfSourceRule.map(las => las.properties.binding.type));
        const hasMatchingAggregateStates = this.aggregateStatesOfSourceRule.filter(las => {
          return statesOfTwinToVerify.findIndex(s => s.properties.binding.type === las.properties.binding.type) >= 0;
        }).length >= uniqueBindingTypes.length;
        if (!hasMatchingAggregateStates) {
          return false;
        }
      }
      const uniqueValueTypesOfSourceRule = uniq(this.statesUsedBySourceRule.map(state => state.properties.valueType));
      const statesWithSameValueTypeBetweenTargetAndOrigin = this.statesUsedBySourceRule.filter(sourceRuleState => {
        const targetTwinStates = Array.isArray(statesOfTwinToVerify) ? statesOfTwinToVerify : [statesOfTwinToVerify];
        return targetTwinStates.some(targetTwinState => targetTwinState.properties.valueType === sourceRuleState.properties.valueType);
      });
      const amountOfStatesWithSameValueTypeBetweenTargetAndOrigin = statesWithSameValueTypeBetweenTargetAndOrigin.length;
      const result = amountOfStatesWithSameValueTypeBetweenTargetAndOrigin >= uniqueValueTypesOfSourceRule.length;
      return result;
    },
    validStatesForMetric(metricStateId, twinStates) {
      const metricState = this.states.find(s => s.id === metricStateId);
      return twinStates.filter(s => {
        return metricState.properties.valueType === s.properties.valueType;
      });
    },
    validStatesForAggregation(aggState, twinStates) {
      return twinStates.filter(s => {
        return aggState.properties.binding.type === s.properties.binding.type;
      });
    },
    onTargetTwinSelected(e) {
      this.selectedTargetTwins.push(e);
      this.targetTwinsStateMetrics[e.id] = {};
      this.targetTwinsAggregateStates[e.id] = {};
    },
    onTargetTwinDeselected(e) {
      this.selectedTargetTwins = this.selectedTargetTwins.filter(t => t.id !== e.id);
      delete this.targetTwinsStateMetrics[e.id];
      delete this.targetTwinsAggregateStates[e.id];
    },
    createRuleCopies() {
      Promise.all(this.selectedTargetTwins.map(twin => {
        const ruleToCreateInTargetTwin = cloneDeep(this.rule);
        ruleToCreateInTargetTwin.dtwinId = twin.id;
        ruleToCreateInTargetTwin.properties.stateMetrics.forEach(metric => {
          metric.stateId = this.targetTwinsStateMetrics[twin.id][metric.key];
        });
        ruleToCreateInTargetTwin.properties.triggeredAggregates.forEach(aggregation => {
          aggregation.stateId = this.targetTwinsAggregateStates[twin.id][aggregation.stateId];
        });
        return ApiService.digitalTwinCreateRule(this, ruleToCreateInTargetTwin);
      })).then(() => {
        this.$snack(this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.copy.copySuccess'), 'success');
        this.$emit('created');
      }).catch(error => {
        console.error(error);
      });
    }
  }
};